/**
 * Import required libraries
 */
import React, { useState, useEffect, useMemo } from "react";
import { loadIcon } from "Utils";

/**
 * BlobIcon Component
 */
function BlobIcon({buffer, alt="", className}) {

  const [imgURL, setImgURL] = useState("");

  const blob = useMemo(() => {
    return new Blob([Buffer.from(buffer)]);
  }, [buffer]);

  useEffect(() => {
    if(blob) {
      loadIcon(blob)
      .then(setImgURL)
      .catch(console.error);
    }
  }, [blob]);

  if(imgURL) {
    return <img className={className} src={imgURL} alt={alt} />;
  } else return null;
}

export default BlobIcon;
